import React from "react";
import { Select } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { getEnabledLanguages } from "../../../../i18n/config";
import { useLocaleStore } from "../../../../store/localeStore";
import { propagarIdiomaALaLanding } from "../../../../i18n/puenteLandingPortal";

/**
 * =============================================================================
 * SELECTOR DE IDIOMA DEL PORTAL
 * =============================================================================
 * Hasta ahora el idioma solo se podia elegir en la landing. Con el frances vivo
 * eso deja atrapado a quien entre en frances: para volver al castellano tendria
 * que cerrar sesion y salir a la web publica.
 *
 * DOS DECISIONES QUE NO SON DE ESTILO:
 *
 * 1. **Si solo hay un idioma encendido, no se pinta nada.** Un desplegable con
 *    una sola opcion no es un control, es ruido — y ademas promete algo que no
 *    hace. El dia que se retire el frances, este selector desaparece solo, sin
 *    que nadie tenga que acordarse de quitarlo.
 *
 * 2. **La eleccion tambien viaja a la landing.** Si alguien pone el portal en
 *    castellano y despues visita la web publica, encontrarsela en frances seria
 *    raro. El puente esta en `i18n/puenteLandingPortal`, que es el sitio donde
 *    vive esta relacion en las dos direcciones.
 *
 * El nombre de cada idioma va SIEMPRE EN SU PROPIO IDIOMA ("Español",
 * "Français") y no traducido. Es lo que hace que alguien que se ha perdido en
 * un idioma que no entiende sepa reconocer el suyo.
 * =============================================================================
 */
export function LanguageSelector() {
  const { t } = useTranslation("common");
  const locale = useLocaleStore((s) => s.locale);
  const setLocale = useLocaleStore((s) => s.setLocale);

  const idiomas = getEnabledLanguages();
  if (idiomas.length < 2) return null;

  const cambiar = (codigo) => {
    setLocale(codigo);
    propagarIdiomaALaLanding(codigo);
  };

  return (
    <Select
      size="small"
      variant="borderless"
      value={locale}
      onChange={cambiar}
      aria-label={t("fields.language")}
      popupMatchSelectWidth={false}
      suffixIcon={<GlobalOutlined />}
      options={idiomas.map((idioma) => ({
        value: idioma.code,
        label: idioma.label,
      }))}
      style={{ minWidth: 108 }}
    />
  );
}
